/* Изглед за гости: английската версия по линка ?lang=en */
(function () {
  try {
    if (new URLSearchParams(location.search).get('lang') !== 'en') return;
    var b = document.querySelector('[data-guest-edition=en]');
    if (b) b.click();
    var ui = document.getElementById('enLang');
    if (ui) ui.click();
  } catch (e) {}
})();
